import React, {Component} from 'react'
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap"
import {ReactComponent as IconHead2} from "../../../assets/icon/icon-head-2.svg"
import {Button, DatePicker, message, Select} from 'antd'
import moment from "moment"
import store from 'store'
import StaticsTableAverage from "./StaticsTableAverage"
import {
    exportProductionTimeStatistics as getExportSku,
    productionTimeStatistics as statisticAverageSku,
} from "../../../services/api/apiBarcode"
import downloadFile from "../../../share/downloadFile"

const {RangePicker} = DatePicker

class StaticsAveragePage extends Component {
    timeout = 0
    state = {
        loading: null,
        downloading: false,
        error: '',
        selectedDate: [moment().subtract(7, 'd'), moment()],
        payload: {
            date_from: moment().subtract(7, 'd').format('DD/MM/YYYY'),
            date_to: moment().format('DD/MM/YYYY'),
        },
        orderType: 'all',
        data: [],
        allSkus: [],
        sku: [],
        fetchKey: Date.now()
    }

    componentDidMount() {
        const wrapper = document.getElementsByClassName('content-wrapper')[0]
        wrapper && wrapper.classList.add('ProductionReportX')

        const dateFilter = store.get('dateFilter')

        if (dateFilter) {
            this.setState({
                selectedDate: [moment(dateFilter.date_from, 'DD/MM/YYYY'), moment(dateFilter.date_to, 'DD/MM/YYYY')],
                payload: {
                    date_from: dateFilter.date_from,
                    date_to: dateFilter.date_to,
                },
            }, () => {
                this._fetchStaticsCreated()
            })
        } else {
            this._fetchStaticsCreated()
        }
    }

    _convertString = (string) => {
        const regex = /,\s|,|\n/
        const parsed = string.split(regex)

        return !!parsed && parsed.length > 0 && parsed.filter(item => item !== "")
    }

    _fetchStaticsCreated = async () => {
        const fetchKey = Date.now()
        this.setState({
            loading: true,
            error: '',
            fetchKey
        })

        return (async (currentFetchKey) => {
            try {
                const {payload, sku = [], orderType} = this.state
                let params = `exclude_note=true&date_from=${payload.date_from}&date_to=${payload.date_to}` + (sku.length ? `&sku=${sku.join(',')}` : '')

                if (orderType && orderType !== 'all') {
                    params += `&order_type=${orderType}`
                }

                const {data: response} = await statisticAverageSku(params)
                const {
                    fetchKey: lastFetchKey
                } = this.state

                // Chỉ update data của API được call cuối cùng
                if (lastFetchKey !== currentFetchKey) {
                    console.log(`You too late! ${currentFetchKey}-${lastFetchKey}`)
                }

                const {success, data, message} = response

                if (!success) {
                    return this.setState({
                        loading: null,
                        error: message,
                    })
                }

                this.setState({
                    loading: false,
                    data: data,
                    allSkus: [...new Set([...(this.state.allSkus || []), ...data.items.map(a => a.type)])],
                })
            } catch (e) {
                this.setState({
                    loading: null,
                    error: e.message,
                })
            }
        })(fetchKey)
    }

    _onChange = (dates) => {
        if (!!dates && dates.length === 2) {
            const date_from = moment(dates[0]).format('DD/MM/YYYY')
            const date_to = moment(dates[1]).format('DD/MM/YYYY')

            this.setState({
                payload: {
                    date_from,
                    date_to,
                },
            }, () => {
                this.setState({
                    selectedDate: dates,
                })
                store.set('dateFilter', {date_from, date_to})
                this._fetchStaticsCreated()
            })
        } else {
            this._fetchStaticsCreated()
        }
    }

    _handleChangeSKu = (e) => {

        if (this.timeout) clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
            this.setState({
                sku: e,
            })
            this._fetchStaticsCreated()
        }, 350)
    }

    _exportSku = async () => {
        this.setState({downloading: true})
        try {
            const {payload, sku, orderType} = this.state
            const rows = await getExportSku({
                date_from: payload.date_from,
                date_to: payload.date_to,
                ...(sku.length && {sku: sku.join(',')}),
                ...(orderType && {order_type: orderType}),
                exclude_note: true
            })

            if (Array.isArray(rows) && !rows.length) {
                return message.warning('Không có dữ liệu để export')
            }

            downloadFile(rows, {
                filePrefix: 'items-produced-',
            })
        } catch (e) {
            message.error(e.message || 'Export thất bại')
        } finally {
            this.setState({downloading: false})
        }
    }

    handleSelectChange = (prop) => (e) => {
        this.setState({[prop]: e}, this._fetchStaticsCreated)
    }

    onOpenChange = (open) => {
        if (open) {
            this.setState({
                selectedDate: [null, null],
            })
        } else {
            this.setState({
                selectedDate: null,
            })
        }
    }

    render() {
        const {selectedDate, data, loading, error, allSkus = [], downloading, orderType = 'all'} = this.state
        const listOrderTypes = [
            {
                name: 'All',
                value: 'all'
            },
            {
                name: 'Đơn thường',
                value: 'normal'
            },
            {
                name: 'FBA',
                value: 'fba'
            },
            {
                name: 'Fast production',
                value: 'fastproduction'
            }
        ]

        return (
            <Row className="">
                <Col md={12}>
                    <div className="StaticsAveragePage StaticsCreatedPage ProductionTime">
                        <Card>
                            <CardHeader className="CardHeader text-white header-elements-inline">
                                <h2 className="card-title d-flex align-items-center">
                                    <IconHead2/>
                                    Thống kê thời gian sản xuất
                                </h2>
                            </CardHeader>
                            <CardBody>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className=" d-flex align-items-center mt-4 mb-4">
                                        <span>Thời gian</span>
                                        <div className="DatePicker SearchDateTime">
                                            <RangePicker
                                                value={selectedDate}
                                                format="DD/MM/YYYY"
                                                onOpenChange={this.onOpenChange}
                                                onChange={this._onChange}
                                            />
                                        </div>
                                        <div className="FilterSkuX">
                                            <Select
                                                mode="multiple"
                                                placeholder="Tìm kiếm theo SKU"
                                                defaultValue={[]}
                                                onChange={this._handleChangeSKu}
                                                allowClear={true}
                                                size="large"
                                                style={{width:'500px', marginLeft: '10px'}}
                                            >
                                                {
                                                    allSkus && !!allSkus.length && allSkus.map(item => {
                                                        return <Select.Option key={item}>{item}</Select.Option>
                                                    })
                                                }
                                            </Select>
                                            {/*<input placeholder="Tìm kiếm theo SKU" onChange={this._handleChangeSKu}/>*/}
                                        </div>
                                    </div>
                                    <div className="Export">
                                        <i className={['BtnRefresh fa fa-refresh', loading && 'disabled spinner'].filter(Boolean).join(' ')}
                                           onClick={this._fetchStaticsCreated} title={'Tải lại'}/>
                                        <Select size="large" className="mr-2" style={{width: '200px'}}
                                                defaultValue={orderType}
                                                onChange={this.handleSelectChange('orderType')}>
                                            {
                                                listOrderTypes.map(type => {
                                                    return <Select.Option
                                                        value={type.value}>{type.name}</Select.Option>
                                                })
                                            }
                                        </Select>
                                        <Button type="default" size="large" disabled={downloading}
                                                onClick={this._exportSku}>
                                            {
                                                downloading && <i className="icon-spinner2 spinner mr-2"/>
                                            }
                                            Export
                                        </Button>
                                    </div>
                                </div>
                                <div className="TableStatics d-flex justify-content-between">
                                    <StaticsTableAverage data={!!data ? data : []} loading={loading} error={error}/>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </Col>
            </Row>
        )
    }
}

export default StaticsAveragePage
